var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Input, Tab } from '@alife/simple-ui';
import Icon from '@alife/next-icon';
var SearchBar = (function (_super) {
    __extends(SearchBar, _super);
    function SearchBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SearchBar.prototype.componentWillReceiveProps = function (nextProps) {
        this.updateSearch(nextProps.keyword);
    };
    SearchBar.prototype.componentDidMount = function () {
        this.updateSearch(this.props.keyword);
    };
    SearchBar.prototype.updateSearch = function (keyword) {
        if (!keyword) {
            this.inputComp.input.value = '';
        }
    };
    SearchBar.prototype.render = function () {
        var _this = this;
        var _a = this.props, _b = _a.locale, locale = _b === void 0 ? {} : _b, options = _a.options, changeType = _a.changeType, changeKeyword = _a.changeKeyword, readType = _a.readType;
        return (React.createElement("div", { className: "search-bar" },
            React.createElement("div", { className: "input-box" },
                React.createElement(Icon, { type: "search", size: "xs" }),
                React.createElement(Input, { ref: function (ref) { return _this.inputComp = ref; }, onChange: changeKeyword, placeholder: locale.sessionFilterPlaceholder })),
            React.createElement(Tab, { options: options, value: readType, onChange: changeType })));
    };
    return SearchBar;
}(React.Component));
export default SearchBar;
//# sourceMappingURL=index.js.map